import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import HelpToolTip from '../../../../../Common/HelpToolTip';
import ContractsDatatable from '../../Datatables/ContractsDatatable';
import ViewAlert from '../../Components/ViewAlert/ViewAlert';
import { withClsCompTracking } from '../../../../../Telemetry/telemetry.service';
import Columns from '../../Datatables/ColumnDefinitions';
import {
	getScriptDatesData,
	addUpdateToScriptDates,
	saveUpdatedScriptDates,
	clearAllScriptDatesUpdates,
	clearUpdateScriptDateErrors,
	removeUpdate,
	removeAllEdits,
	getScriptDatesCount
} from '../../../../../Redux/Actions/Script.Dates.Actions';
import CloseButton from '../../../../../Common/CloseButton/CloseButton';
import SaveButton from '../../Components/SaveButton/SaveButton';
import classes from '../contract-views.module.css';
import useScriptDates from "../../Datatables/hooks/useScriptDates";
import Page from '../../../../../Common/Layout/Page';
import Section from '../../../../../Common/Layout/Section';
import Panel from '../../../../../Common/Layout/Panel';
import TeamTypeFilter from '../../../../../Common/Components/TeamTypeFilter/TeamTypeFilter.container';
import { qualYearSelect } from 'Redux/Selectors/Contracts.Globals.Selectors';
import Refiner from '../../../../../Common/Components/Refiner/Refiner.container';
import Updater from '../../../Generic/Appointments/Components/Updater/Updater.container';
import viewTypes from '../../../Generic/Appointments/Components/Updater/ViewType.constants';

const ScriptDatesManagement = withClsCompTracking('Script Dates Management')(ContractsDatatable);

const ScriptDates = ({ handleActiveModal, appointeeType = 'Marker' }) => {
	document.title = "Contract Management - Script Delivery and Return Dates";
	const { selected: qualYear } = useSelector(qualYearSelect);	
	let [scriptyear, setYear] = useState(qualYear.toString());
	const dispatch = useDispatch();
	const [fireShow, setFireShow] = useState(false);
	const types = useSelector(state => state.contract_globals.appointment_types.selected);
	const scriptdates = useSelector(state => state.scriptdates);
	const handleGetScriptDates = (contractTypes, year, query, exportData, teamIds, isRefine, refineFields, groupUpdaterFields) => 
		dispatch(getScriptDatesData(contractTypes, year, query, exportData, teamIds, isRefine, refineFields, groupUpdaterFields));
	const handleSaveScriptDates = (contractTypes, year, data) => dispatch(saveUpdatedScriptDates(contractTypes, year, data));
	const handleScriptDateUpdate = (field, value, data, updates) => dispatch(addUpdateToScriptDates(field, value, data, updates));
	const handleScriptDateErrorClear = () => dispatch(clearUpdateScriptDateErrors());
	const handleClearScriptDateUpdates = () => dispatch(clearAllScriptDatesUpdates());
	const handleRemoveUpdate = (keyField, id, updates) => dispatch(removeUpdate(keyField, id, updates));
	const handleRemoveAllEdits = () => dispatch(removeAllEdits());
	const handleScriptDateCount = (contractTypes, year) => dispatch(getScriptDatesCount(contractTypes, year));
	const handleQualyearUpdate = (year) => setYear(year);	
	const saveGroupUpdater = (contractTypes, year, data) => dispatch(saveUpdatedScriptDates(contractTypes, year, data));

	const saveContractFees = () => {
		handleSaveScriptDates(types, scriptyear, scriptdates.updated);
		setFireShow(true);
	};
	const amendments = scriptdates.updated.length;

	const { filterOpen, toggleFilter, isFiltering, setIsFiltering, year, updateYear, startNewFilter, handleFilterClear, handleFilterSubmit,
		refinerFields, refinerOpen, inPreview, refineData, onRefinementSelectorsChange, onRefinementSelectorsRemove, onRefinementAllClear, toggleRefiner,
		updaterOpen, toggleUpdater, setInPreview, startNewUpdate, updateDataTable, saveData, groupUpdaterFields, displayData, groupUpdaterData,
        displayAppointmentsName, viewDataOpen, setViewDataOpen, toggleViewData, isYearChange, isLoaded, selectedTypes, selectedTeamIds,
		setPageDetails, refineFields, resetPageNo, isPageReset
	} = useScriptDates(handleClearScriptDateUpdates, handleGetScriptDates, saveGroupUpdater);

	const defaultTitle = year ? `${year} ${appointeeType} Appointments` : '';
	const displayTitle = displayAppointmentsName ? `${defaultTitle} ${displayAppointmentsName}` : defaultTitle;

	return (
		<Page title="Script Delivery and Return Dates">
			<Section>
				<TeamTypeFilter
					open={filterOpen}
					togglePanel={toggleFilter}
					isFiltering={isFiltering}
					setIsFiltering={setIsFiltering}
					grouping={appointeeType}
                    year={year}
                    numberOfFutureYears={1}
					updateYear={updateYear}
					startNewFilter={startNewFilter}
					onClear={handleFilterClear}
					onSubmit={handleFilterSubmit}
				/>
			</Section>
			<Section>
				<Refiner
                    disabled={isFiltering}
                    fields={refinerFields}
					open={refinerOpen}
					readOnly={inPreview}
					data={refineData}
					onRefinementSelectorsChange={onRefinementSelectorsChange}
					onRefinementSelectorsRemove={onRefinementSelectorsRemove}
					onRefinementAllClear={onRefinementAllClear}
					onPanelToggleClick={toggleRefiner}
				/>
			</Section>
			<Section>
				<Updater
                    disabled={isFiltering}
					year={year}
					updaterOpen={updaterOpen}
					setUpdaterOpen={toggleUpdater}
					grouping={appointeeType}
					inPreview={inPreview}
					setInPreview={setInPreview}
					isFiltering={isFiltering}
					refinedAppointments={groupUpdaterData}
					viewDataOpen={viewDataOpen}
					setViewDataOpen={setViewDataOpen}
                    startNewUpdate={startNewUpdate}
					isMarker={true}
					updateDataTable={updateDataTable}
					saveData={saveData}
					displayData={displayData}
					updateViewType={viewTypes.ScriptDates}
				/>
			</Section>
			<Section>
				<Panel variant='default' open={viewDataOpen} disabled={isFiltering} title={displayTitle} onToggle={toggleViewData}>
					{ (viewDataOpen || (year && !isYearChange && isLoaded)) && ( <div>	
						<HelpToolTip title={`Script Dates Editing Help`} />
						<ViewAlert
							show={scriptdates.message !== ''}
							message={scriptdates.message}
							errors={scriptdates.errors}
							clearMessage={handleScriptDateErrorClear}
						/>
					
						<ScriptDatesManagement
							keyField={'markingTeamId'}
							tableName="script-dates"
							columns={Columns.ScriptDatesColumns}
							contractTypes={selectedTypes}
							year={year}
							teamIds={selectedTeamIds}
							setPageDetails={setPageDetails}
							resetPageNo={resetPageNo}
							isPageReset={isPageReset}
							refineFields={refineFields}
							groupUpdaterFields={groupUpdaterFields}
							handleGetData={handleGetScriptDates}
							handleAddUpdates={handleScriptDateUpdate}
							handleClearUpdates={handleClearScriptDateUpdates}
							removeUpdate={handleRemoveUpdate}
							handleRemoveAllEdits={handleRemoveAllEdits}
							handleGetCount={handleScriptDateCount}
							updateQualYear={handleQualyearUpdate}
							fireShow={fireShow}
							setFireShow={setFireShow}
							amendments={amendments}
							dispatch={dispatch}
							{...scriptdates}			
						/>
					</div>)}
					<span className={classes['action-buttons']}>
						<CloseButton closeOnClick={() => handleActiveModal('')} hasUpdates={scriptdates.updated && scriptdates.updated.length > 0} />
						{ (viewDataOpen || (year && !isYearChange && isLoaded)) 
							&& <SaveButton saveOnClick={saveContractFees} disabled={ amendments === 0 } /> }
					</span>	
				</Panel>			
			</Section>
		</Page>
	);
};

export default ScriptDates;
